export default function userSessionCheck() {
  setInterval(() => {
    if (localStorage.getItem('ns_t') == null || !localStorage.getItem('ns_t')) {
      // Redirect to /auth app when token is invalid/missing
      const currentOrigin = window.location.origin;
      window.location.href = `${currentOrigin}/auth/?r=webphone`;
    }
  }, 2500);
}
